import { TypeModel } from './type.model';

export class PointOfSalesModel {
    public types: TypeModel[];
}